import React from 'react';
import './Navbar.css';
import aiCardImg from '../1398494.jpg';
import logoImg from '../logo.png';

const DropdownIcon = () => (
  <svg className="dropdown-icon" viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

const Navbar = ({ onNavigate, onContactClick, activePage }) => {
  const [showServices, setShowServices] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const aiServices = [
    "Agentic AI Automations", "Voice AI", "Chatbot Development", "Natural Language Processing",
    "Microsoft Fabric Consulting", "RAG Services", "Gen AI",
    "Data Analytics Services", "LLM Development", "Business Intelligence"
  ];

  const categories = [
    { name: "Artificial Intelligence", active: true }
  ];

  return (
    <nav className="navbar" onMouseLeave={() => setShowServices(false)}>
      <div className="logo-container" onClick={() => onNavigate('portfolio')} style={{ cursor: 'pointer' }}>
        <img src={logoImg} className="navbar-logo-img" alt="Cabptoid Logo" />
        <div className="logo-text-group">
          <span className="logo-text">Cabptoid</span>
          <span className="logo-subtitle">SOLUTIONS</span>
        </div>
      </div>

      <div className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <a
          href="#portfolio"
          className={`nav-link ${activePage === 'portfolio' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); onNavigate('portfolio'); setIsMobileMenuOpen(false); }}
        >
          PORTFOLIO
        </a>
        <div className="nav-item-container">
          <a
            href="#services"
            className={`nav-link ${showServices ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              setShowServices(!showServices);
            }}
          >
            SERVICES <DropdownIcon />
          </a>

          {showServices && (
            <div className="mega-menu">
              <div className="mega-menu-content">
                {/* Left Sidebar */}
                <div className="mega-sidebar">
                  {categories.map((cat, i) => (
                    <div key={i} className={`sidebar-item ${cat.active ? 'active' : ''}`}>
                      {cat.name}
                      <span className="arrow">›</span>
                    </div>
                  ))}
                </div>

                {/* Center Content */}
                <div className="mega-main">
                  <div className="category-title">ARTIFICIAL INTELLIGENCE</div>
                  <div className="services-list">
                    {aiServices.map((service, i) => {
                      const servicePageMap = {
                        "Agentic AI Automations": "agentic-ai",
                        "Voice AI": "voice-ai",
                        "Chatbot Development": "chatbot",
                        "Natural Language Processing": "nlp",
                        "Microsoft Fabric Consulting": "ms-fabric",
                        "RAG Services": "rag",
                        "Gen AI": "gen-ai",
                        "Data Analytics Services": "data-analytics",
                        "LLM Development": "llm",
                        "Business Intelligence": "bi"
                      };
                      const pageKey = servicePageMap[service];
                      return (
                        <div 
                          key={i} 
                          className="service-item"
                          onClick={(e) => {
                            e.preventDefault();
                            if (pageKey) {
                              onNavigate(pageKey);
                              setShowServices(false);
                              setIsMobileMenuOpen(false);
                            }
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <span className="play-icon">▶</span>
                          {service}
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Right Card */}
                <div className="mega-card">
                  <div
                    className="card-image-placeholder"
                    style={{ backgroundImage: `url(${aiCardImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                  >
                    <div className="ai-overlay-text">Artificial Intelligence</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <a
          href="#industries"
          className={`nav-link ${activePage === 'industries' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); onNavigate('industries'); setIsMobileMenuOpen(false); }}
        >
          INDUSTRIES <DropdownIcon />
        </a>
        <a
          href="#about"
          className={`nav-link ${activePage === 'about' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); onNavigate('about'); setIsMobileMenuOpen(false); }}
        >
          ABOUT US <DropdownIcon />
        </a>
        <a
          href="#insights"
          className={`nav-link ${activePage === 'insights' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); onNavigate('insights'); setIsMobileMenuOpen(false); }}
        >
          INSIGHTS
        </a>
        <button className="action-btn mobile-only" onClick={() => { onContactClick(); setIsMobileMenuOpen(false); }}>Get in Touch</button>
      </div>

      <button className="action-btn desktop-only" onClick={onContactClick}>Get in Touch</button>
      
      <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
        {isMobileMenuOpen ? '✕' : '☰'}
      </button>
    </nav>
  );
};

export default Navbar;
